var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.57367 2.09131L0.985753 9.75048C0.891161 9.91429 0.84111 10.1 0.84058 10.2892C0.840051 10.4783 0.889061 10.6643 0.982734 10.8287C1.07641 10.993 1.21148 11.13 1.37451 11.2259C1.53754 11.3218 1.72285 11.3734 1.912 11.3755H11.0878C11.277 11.3734 11.4623 11.3218 11.6253 11.2259C11.7884 11.13 11.9234 10.993 12.0171 10.8287C12.1108 10.6643 12.1598 10.4783 12.1593 10.2892C12.1587 10.1 12.1087 9.91429 12.0141 9.75048L7.42617 2.09131C7.32961 1.93212 7.19364 1.8005 7.0314 1.70916C6.86916 1.61781 6.68611 1.56982 6.49992 1.56982C6.31373 1.56982 6.13068 1.61781 5.96844 1.70916C5.8062 1.8005 5.67023 1.93212 5.57367 2.09131V2.09131Z",
    stroke: "black",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.875V7.04167",
    stroke: "black",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.20801H6.50667",
    stroke: "black",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/AlertTriangle.b2b141fef996c4e103a57d60eb0cf09d.svg";
export { ForwardRef as ReactComponent };